import React, { useState } from "react";
import "./OrganizationDetails.css";
import { Outlet } from "react-router-dom";
import HeaderBar from "../Sidebar4/HeaderBar";
import Sidebar from "../Sidebar4/Sidebar";

const OrganizationDetails = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false)

  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle)
  }

  return (
    <>
    <div className="container dashboard-height">
      <div className="card card-height">
        
          <div className="row grid-container">
          <div className=" col-xl-3  col-lg-4 col-sm-0 col-xs-0 sidepanel">
         
          <HeaderBar OpenSidebar={OpenSidebar}/>
          <Sidebar openSidebarToggle={openSidebarToggle} OpenSidebar={OpenSidebar}/>
          
          </div>
          
          <div className=" col-xl-9 col-lg-8 col-sm-12 col-xs-12 outlet-height outlet-scrollbar">
            <Outlet />
          </div>
          </div>
      
      </div>
      </div>
    </>
  );
};

export default OrganizationDetails;
